/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetDataConnectionDetailsForGraphNodeQueryVariables = Types.Exact<{
  dataConnectionId: Types.Scalars["DataConnectionId"]["input"];
}>;

export type GetDataConnectionDetailsForGraphNodeQuery = {
  readonly __typename: "Query";
  readonly dataConnectionById: {
    readonly __typename: "DataConnection";
    readonly id: c.DataConnectionId;
    readonly connectionType: c.DataConnectionType;
    readonly connectionName: string;
  };
};

export const GetDataConnectionDetailsForGraphNodeDocument = /*#__PURE__*/ gql`
  query GetDataConnectionDetailsForGraphNode(
    $dataConnectionId: DataConnectionId!
  ) {
    dataConnectionById(dataConnectionId: $dataConnectionId) {
      id
      connectionType
      connectionName
    }
  }
`;

/**
 * __useGetDataConnectionDetailsForGraphNodeQuery__
 *
 * To run a query within a React component, call `useGetDataConnectionDetailsForGraphNodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataConnectionDetailsForGraphNodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataConnectionDetailsForGraphNodeQuery({
 *   variables: {
 *      dataConnectionId: // value for 'dataConnectionId'
 *   },
 * });
 */
export function useGetDataConnectionDetailsForGraphNodeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDataConnectionDetailsForGraphNodeQuery,
    GetDataConnectionDetailsForGraphNodeQueryVariables
  > &
    (
      | {
          variables: GetDataConnectionDetailsForGraphNodeQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDataConnectionDetailsForGraphNodeQuery,
    GetDataConnectionDetailsForGraphNodeQueryVariables
  >(GetDataConnectionDetailsForGraphNodeDocument, options);
}
export function useGetDataConnectionDetailsForGraphNodeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDataConnectionDetailsForGraphNodeQuery,
    GetDataConnectionDetailsForGraphNodeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDataConnectionDetailsForGraphNodeQuery,
    GetDataConnectionDetailsForGraphNodeQueryVariables
  >(GetDataConnectionDetailsForGraphNodeDocument, options);
}
export function useGetDataConnectionDetailsForGraphNodeSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetDataConnectionDetailsForGraphNodeQuery,
    GetDataConnectionDetailsForGraphNodeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDataConnectionDetailsForGraphNodeQuery,
    GetDataConnectionDetailsForGraphNodeQueryVariables
  >(GetDataConnectionDetailsForGraphNodeDocument, options);
}
export type GetDataConnectionDetailsForGraphNodeQueryHookResult = ReturnType<
  typeof useGetDataConnectionDetailsForGraphNodeQuery
>;
export type GetDataConnectionDetailsForGraphNodeLazyQueryHookResult =
  ReturnType<typeof useGetDataConnectionDetailsForGraphNodeLazyQuery>;
export type GetDataConnectionDetailsForGraphNodeSuspenseQueryHookResult =
  ReturnType<typeof useGetDataConnectionDetailsForGraphNodeSuspenseQuery>;
export type GetDataConnectionDetailsForGraphNodeQueryResult =
  Apollo.QueryResult<
    GetDataConnectionDetailsForGraphNodeQuery,
    GetDataConnectionDetailsForGraphNodeQueryVariables
  >;
